import React, { useState } from 'react';
import { TableRow, TableCell, Tooltip, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { getLocalStorageInfo } from '../../../../utils';
import { checkPermission } from '../../../../utils_v2';
import { displayDateFormatShort } from '../../../../constants';
import { AttachmentsRow } from '../../components';
import EolObligationCRU from './EolObligationCRU';
export default function EolObligationList({item, previewDetail, getResponseBack, reserveAccounts, contractInfo,deleteEolList}){
  const [showMore, setShowMore] = useState({});
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  return(
    <TableRow hover tabIndex={-1}>
      <TableCell><div style={{width:'250px'}}>{item?.reserve_account?.name||'--'}</div></TableCell>
      <TableCell>{item?.excess_refund||'--'}</TableCell>
      <TableCell>{item?.compensation_time||'--'}</TableCell>
      <TableCell>{item?.compensation_type||'--'}</TableCell>
      <TableCell>{item?.compensation_base||'--'}</TableCell>
      {/* <TableCell>
      {item?.remarks && item?.remarks?.length > 200 ? (
          <div style={{ maxWidth: '400px' }}>
            {showMore[item?.id] && showMore[item?.id] ? (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.remarks.replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id); }} >
                  less
                </a>
              </span>
            ) : (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.remarks.substring(0, 190).replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.id); }} >
                  ..more
                </a>
              </span>
            )}
          </div>
        ) : (
          <div>
                <span dangerouslySetInnerHTML={{ __html: item?.remarks.replace(/\n/g, '<br />') }} />
          </div>
        )}
      </TableCell> */}
      <TableCell>{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell> 
      <TableCell style={{textAlign:'right'}}>
        <EolObligationCRU id={item.id} m="V" reserveAccounts={reserveAccounts} getResponseBack={getResponseBack}  contractInfo={contractInfo} />
        {checkPermission('contracts','eol_obligation', 'D') ?<DeleteIcon fontSize='small' color='secondary' onClick={()=>deleteEolList(item.id)}/>:null}
      </TableCell>
    </TableRow>
  )
}
